import { LanguageModel } from '@prz-dp/services';
import { deburr, orderBy } from 'lodash-es';
import Vue from 'vue';

export const setupLang = async (vueInstance: Vue) => {
  const supportedLanguages: LanguageModel[] = orderBy(
    [
      { code: 'de', locale: 'de-DE', name: 'Deutsch - German' },
      { code: 'el', locale: 'el-GR', name: 'Ελληνικά - Greek' },
      { code: 'en', locale: 'en-US', name: 'English' },
      { code: 'es', locale: 'es-ES', name: 'Español - Spanish' },
      { code: 'fi', locale: 'fi-FI', name: 'Suomi - Finnish' },
      { code: 'fr', locale: 'fr-FR', name: 'Français - French' },
      { code: 'it', locale: 'it-IT', name: 'Italiano - Italian' },
      { code: 'pl', locale: 'pl-PL', name: 'Polski - Polish' },
      { code: 'pt', locale: 'pt-PT', name: 'Português - Portuguese' }
    ],
    [(language) => deburr(language.name).toLowerCase()],
    ['asc']
  );

  vueInstance.$kit.lang.setSupportedLanguages(supportedLanguages);

  vueInstance.$kit.lang.setFallback('en');

  const currentLanguage = await vueInstance.$kit.lang.getCurrentLanguage();

  const result = await vueInstance.$kit.lang.setCurrentLanguage(
    currentLanguage
  );

  if (result) {
    vueInstance.$root.$i18n.locale = result.locale;
    vueInstance.$moment.locale(result.code);
  }
};
